import React from 'react';

import {useSuspenseCmsContent} from 'coreHooks';

import {Contentful} from 'brand/app/contentful/components';

import {
	FooterCopyright,
	FooterMobileApp,
	FooterNavigation,
	FooterNewsletter,
	FooterSelectors} from './Subcomponents';

// eslint-disable-next-line no-restricted-imports
import './Footer.scss';

/**
 * Suspends on its CMS content: below the `NonCriticalBoundary` of `App`, on the server it does not hold the
 * shell and is streamed after it when the CMS is slower than the page (`app.ssrStreaming.footer`, PLAN.md 2b.7c).
 */
const Footer = () => {
	const {data: footerData} = useSuspenseCmsContent({
		contentType: 'footer',
		collectionKey: 'footerCollection',
		refetchOnMount: 'always'
	});

	return (
		<>
			<footer className="footer">
				{!!footerData && <Contentful initialData={footerData} />}
			</footer>
		</>
	);
};

Footer.Navigation = FooterNavigation;
Footer.Selectors = FooterSelectors;
Footer.Newsletter = FooterNewsletter;
Footer.MobileApp = FooterMobileApp;
Footer.Copyright = FooterCopyright;

export default Footer;
